import { expectString } from "./schema";
export const TENANT_SERVICE_CATEGORIES = ["dance", "music", "sports", "academic", "art", "other"];
export const TENANT_UI_LABEL_PROFILES = ["dance", "genericLesson", "sports", "music", "academic", "art"];
function parseStringEnum(value, allowedValues, path) {
    const parsed = expectString(value, path);
    if (!allowedValues.includes(parsed)) {
        throw new Error(`${path} must be one of: ${allowedValues.join(", ")}`);
    }
    return parsed;
}
export function parseTenantServiceCategory(value, path = "tenantServiceCategory") {
    return parseStringEnum(value, TENANT_SERVICE_CATEGORIES, path);
}
export function parseTenantUiLabelProfile(value, path = "tenantUiLabelProfile") {
    return parseStringEnum(value, TENANT_UI_LABEL_PROFILES, path);
}
